export const environment = {
  production: false,
  endpoint: 'dev',
  client: {
    name: 'postman',
    secret: 'AY0iVk6Vor'
  }
};
